export const DEFAULT_GAME_LIMIT = 16;
export const INFINITE_SCROLL_ROOT_MARGIN = "400px";
export const LOAD_MORE_SKELETON_COUNT = 8;
/** How many lists are kept for Back, and how long one stays good, in ms. */
export const SNAPSHOT_LIMIT = 8;
export const SNAPSHOT_TTL_MS = 5 * 60 * 1000;
